//View Keys
export default {
	templateEdit_create: 'Create item',
	templateEdit_edit: 'Edit item',
	templateList_firstName: 'First Name',
	templateList_lastName: 'Last Name',

	templateList_saveSuccessfully: 'Successfully saved message',
};
